// CDN (Consignment Delivery Note) form. Thin wrapper around the shared
// DeliveryNoteForm — see that file for the actual form logic. Only the
// document type differs here; keep this file thin rather than duplicating
// form code (that duplication is exactly what this wrapper replaced).
import DeliveryNoteForm from "../shared/DeliveryNoteForm.jsx";

const ProformaInvoice = () => <DeliveryNoteForm variant="cdn" />;

export default ProformaInvoice;
